import type { Rng } from '../core/rng';
import type { BuildContext } from './types';
import { planLots, type PlannedLots } from './fabric/fabricLots';

/**
 * The lots of the whole world, planned once before any feature builds, so the fabric builds on
 * them and the streetscape paves before them. They draw from the stream the fabric feature once
 * planned them on, the world rng's `fabric` fork forked `fabric` again, so the plan is the one the
 * fabric made for itself.
 */
export function planWorldLots(ctx: Pick<BuildContext, 'layout' | 'site'>, world: Rng): PlannedLots {
  return planLots(ctx, world.fork('fabric').fork('fabric'));
}
